import StyledSpinner from "./StyledSpinner";

type StyledSecondaryActionButtonProps = {
  onClick: () => void;
  text: string;
  isLoading?: boolean;
  type?: "button" | "submit";
};

export const StyledSecondaryActionButton = ({
  onClick,
  text,
  isLoading = false,
  type = "button",
}: StyledSecondaryActionButtonProps) => {
  return (
    <button
      type={type}
      disabled={isLoading}
      onClick={onClick}
      className="h-fit w-full rounded-lg border border-gray-200 bg-white px-4 py-3 text-base font-semibold text-black hover:border-gray-300 hover:bg-gray-50 disabled:bg-gray-200"
    >
      {isLoading ? <StyledSpinner width="20" height="20" /> : text}
    </button>
  );
};
